var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e5203a991d96d6c37182baeb026683b18e24858d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@higher-learning-technologies"]={id:"e5203a991d96d6c37182baeb026683b18e24858d"};
      